import { useState } from 'react';

import { Menu, MenuItem, Typography } from '@/ui';

import type { FilterOption } from './types';
import type { FC } from 'react';

interface FilterDropdownProps {
  label: string;
  onChange: (selected: string[]) => void;
  options: FilterOption[];
  selected: string[];
}

const FilterDropdown: FC<FilterDropdownProps> = ({
  label,
  onChange,
  options,
  selected,
}) => {
  const [anchorEl, setAnchorEl] = useState<HTMLElement | null>(null);
  const open = Boolean(anchorEl);

  const handleClick = (event: React.MouseEvent<HTMLButtonElement>) => {
    setAnchorEl(event.currentTarget);
  };

  const handleClose = () => {
    setAnchorEl(null);
  };

  const handleToggle = (optionId: string) => {
    if (selected.includes(optionId)) {
      onChange(selected.filter((s) => s !== optionId));
    } else {
      onChange([...selected, optionId]);
    }
  };

  const hasSelection = selected.length > 0;

  return (
    <>
      <button
        className={`inline-flex items-center gap-1 rounded-full px-3 py-1.5 text-xs font-medium transition-colors ${
          hasSelection
            ? 'bg-sage-100 text-sage-600'
            : 'bg-white text-cement-500'
        }`}
        style={{ border: '1px solid #A4A4A4' }}
        type="button"
        onClick={handleClick}
      >
        {label}
        {hasSelection && (
          <span className="text-sage-500">({selected.length})</span>
        )}
        <span className="material-icons text-base">
          {open ? 'expand_less' : 'expand_more'}
        </span>
      </button>
      <Menu
        anchorEl={anchorEl}
        anchorOrigin={{ horizontal: 'left', vertical: 'bottom' }}
        open={open}
        slotProps={{
          paper: {
            style: { borderRadius: '8px', marginTop: 4, minWidth: 160 },
          },
        }}
        transformOrigin={{ horizontal: 'left', vertical: 'top' }}
        onClose={handleClose}
      >
        {options.map((option) => (
          <MenuItem
            key={option.id}
            selected={selected.includes(option.id)}
            style={{ fontSize: '13px', paddingBottom: 6, paddingTop: 6 }}
            onClick={() => handleToggle(option.id)}
          >
            <Typography variant="body2">{option.name}</Typography>
          </MenuItem>
        ))}
      </Menu>
    </>
  );
};

export default FilterDropdown;
